<div class="action-card" matRipple [matRippleDisabled]="!interactive || disabled">
  <div class="action-card__icon">
    @if (icon) {
      <mat-icon class="material-symbols-outlined">{{ icon }}</mat-icon>
    }
    <ng-content select="[actionCardIcon]"></ng-content>
  </div>

  <div class="action-card__content">
    @if (title) {
      <span class="action-card__title">{{ title }}</span>
    }

    @if (subTitle) {
      <span class="action-card__sub-title">{{ subTitle }}</span>
    }

    <div class="action-card__description">
      @if (description) {
        <span>{{ description }}</span>
      }
      <ng-content></ng-content>
    </div>

  </div>

  <div class="action-card__actions">
    <ng-content select="[cardActions]"></ng-content>
  </div>
</div>
